<template>
  <div class="main">
    <div class="content" v-if="type==0">
      <img src="@images/tip-wait.png">
      <div class="title">您的资料已提交到后台正在审核中！</div>
      <el-button type="primary" class="mat20" @click="goRZ">关闭</el-button>
    </div>
    <div class="content" v-if="type==1">
      <img src="@images/tip-error.png">
      <div class="title">您的申请志愿者资格机会已用光</div>
      <el-button type="primary" class="mat20" @click="goRZ">关闭</el-button>
    </div>
    <div class="content" v-if="type==2">
      <img src="@images/tip-error.png">
      <div class="title">本次申请已驳回：{{reason}}</div>
      <div class="warning">您还有{{obj}}次资料提交机会！</div>
      <el-button type="primary" class="mat20" v-if="obj&&obj>0" @click="goRegister('update')">重新注册</el-button>
      <el-button type="primary" class="mat20" v-else @click="goRZ">关闭</el-button>
    </div>

    <div class="content" v-if="type==3">
      <img src="@images/tip-none.png">
      <div class="title">您没能通过试用期，请重新来过！</div>
      <div class="tips">驳回原因：试用期不合格</div>
      <div class="warning">您还有{{obj}}次资料提交机会！</div>
      <el-button type="primary" class="mat20" v-if="obj&&obj>0" @click="goRegister('update')">重新注册</el-button>
      <el-button type="primary" class="mat20" v-else @click="goRZ">关闭</el-button>
    </div>

    <div class="content" v-if="type==5">
      <img src="@images/tip-error.png">
      <div class="title">您的申请保留资格审批中，请耐心等待！</div>
      <el-button type="primary" class="mat20" @click="goRZ">关闭</el-button>
    </div>

    <div class="content" v-if="type==6">
      <img src="@images/tip-error.png">
      <div class="title">您的申请保留资格被驳回，您已退出志愿者系统！</div>
      <div class="tips">驳回原因：{{obj}}</div>
      <el-button type="primary" class="mat20" @click="goRZ">关闭</el-button>
    </div>

    <div class="content" v-if="type==7">
      <img src="@images/tip-error.png">
      <div class="title">您本年度积分不合格，暂无保留资格申请</div>
      <el-button type="primary" class="mat20" @click="goRZ">关闭</el-button>
    </div>

    <div class="content" v-if="type==8">
      <img src="@images/tip-error.png">
      <div class="title">您本年度积分不合格，是否申请保留资格？</div>
      <div class="tips">{{obj}}</div>
      <el-button type="primary" class="mat20" @click="apply">申请</el-button>
      <el-button class="mat20" @click="goRZ">关闭</el-button>
    </div>

    <div class="content" v-if="type==10">
      <img src="@images/tip-quit.png">
      <div class="title">您已退出志愿者系统！</div>
      <el-button type="primary" class="mat20" @click="goRZ">关闭</el-button>
    </div>

  </div>
</template>

<script>
import gl from '@/api/global';
export default {
  components: {},
  data() {
    return {
      type: this.$route.params.status,
      userMess: this.$store.state.user.user,
      obj: this.$route.params.obj,
      reason: this.$route.params.refuseReason
    };
  },
  computed: {},
  watch: {},
  methods: {
    goRegister(val) {
      this.$router.push({ name: 'register', params: { type: val } })
    },
    goRZ() {
      window.location.href = gl.rzUrl
    },
    apply() {
      this.$api.keeyQuality({ volunteerId: this.userMess.id }).then(res => {
        // console.log(res)
        if (res.code == 0) {
          this.$message.error(res.message);
        } else {
          this.$message.success(res.message);
          if (this.obj == "上年所欠时长需要在今年补齐") {
            this.$router.push({ name: "home" })
          } else {
            setTimeout(function () {
              window.location.href = gl.rzUrl
            }, 1000)
          }
        }
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // console.log(this.type)
    this.$store.commit('setLoading', false);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.main {
  position: relative;
  .content {
    width: 700px;
    margin: 100px auto;
    text-align: center;
    background-color: #fff;
    padding: 50px 0;
    img {
      width: 100px;
      margin: 12px 0;
    }
    .title {
      font-size: 18px;
    }
    .tips {
      color: @font-grey;
      font-size: 14px;
      margin: 6px 0;
    }
    .warning {
      color: @font-orange;
      font-size: 14px;
    }
  }
}
</style>
